import request from '@/utils/request';

const PATH = '/stay';

export const getStayList = () => request({
  url: PATH,
  method: 'get',
});

export const getStayCalendarInfo = (params: any) => request({
  url: `${PATH}/calendar`,
  method: 'get',
  params,
});

export const addStay = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});

export const updateStay = (idx: any, data: any) => request({
  url: `${PATH}/${idx}`,
  method: 'put',
  data,
});

export const updateRefundPolicyInfo = (idx: any, data: any) => request({
  url: `${PATH}/${idx}`,
  method: 'put',
  data,
});
